import React from 'react';
import { HEADER_BAR_RIGHT_CONTENT } from './targets';
import UniquePortal from './UniquePortal';

interface Props {
	children?: JSX.Element;
	priority?: number;
}

const SetPageHeaderRightContent = React.memo(({ children, priority = 0 }: Props) => {
	return (
		<UniquePortal target={HEADER_BAR_RIGHT_CONTENT} priority={priority}>
			{children}
		</UniquePortal>
	);
});

export default SetPageHeaderRightContent;
